var React = require('react');

function IconDoorClosed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M416 48c8.8 0 16 7.2 16 16V464H144V64c0-8.8 7.2-16 16-16H416zm64 416V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64V464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H96h48H432h48 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H480zM368 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"}));
}

IconDoorClosed.defaultProps = {"viewBox":"0 0 576 512","fill":"currentColor"};

module.exports = IconDoorClosed;

IconDoorClosed.default = IconDoorClosed;
